@if (currentViewType === viewType.Mobile) {
	<!-- Ohne @defer: die mobile Katalogansicht ist der wichtigste SEO-Pfad, und ein @defer
	     hier kostete eine eigene Netzrunde, bevor der Katalog gerendert werden konnte.
	     Der Desktop-Zweig unten bleibt bewusst nachgeladen. -->
	<app-catalog-mobile />
} @else {
	@defer (on immediate) {
		<app-catalog-desktop />
	}
}
